export const ANALYTICS_COLORS = [
    '#2563eb',
    '#F4B648',
    '#16a34a',
    '#dc2626',
    '#9333ea',
    '#0891b2',
    '#ea580c',
    '#db2777',
    '#4f46e5',
    '#65a30d',
    '#0f766e',
    '#c026d3',
    '#ca8a04',
    '#475569',
    '#be123c',
];


export function getStableColor(key, colors = ANALYTICS_COLORS) {
    if (!key) {
        return colors[0];
    }

    const normalizedKey = String(key).trim().toLowerCase();

    let hash = 0;

    for (let i = 0; i < normalizedKey.length; i++) {
        hash = normalizedKey.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
}
